import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from '../../../config/app-constants';
import { ACCOUNTS_API_ENDPOINTS, BILLING } from '../../../endpoints.const';
import { LoaderService } from '../../core/services/loading.service';

@Injectable({
    providedIn: 'root'
})
export class BillingService {
    constructor(public http: HttpClient, public loaderService: LoaderService) { }

    postData(payload: any): Observable<any> {
        let url = `${AppConstants.APP_BASE_API_URL}${BILLING.BILLING}`;
        return this.http.post<any>(url, payload);
    }

    fetchBillingDataAccordion(payload: any): Observable<any> {
        let url = `${AppConstants.APP_BASE_API_URL}${ACCOUNTS_API_ENDPOINTS.PANELS}`;
        return this.http.post<any>(url, payload );
    }
}
